import type { BrandTheme } from "@/lib/brand-theme";
import { getLogoHeightClass } from "@/lib/brand-theme";
import { useTheme } from "@/lib/theme/ThemeProvider";

export function BrandLogo({ brand }: { brand: BrandTheme | null }) {
  const { resolvedTheme } = useTheme();
  const logo = brand && resolvedTheme === "dark" && brand.logo_dark_mode
    ? brand.logo_dark_mode
    : brand?.logo_url;

  return logo ? (
    <img src={logo} alt={brand?.name ?? "Store"} className={`${getLogoHeightClass(brand?.logo_size)} w-auto`} />
  ) : (
    <div className="text-[18px] font-semibold text-(--color-text-primary)">{brand?.name || "Checkout"}</div>
  );
}
